export default __webpack_public_path__ + "static/media/image_2.0aa319f8.jpg";